/**
 * The accountant's CSV files (Utlegg, Innsamling, Kontantgaver), written one way.  2026-10-29.
 *
 * Semicolons between cells (Norwegian Excel), CRLF after every line, the last one included.
 *
 *  - cell(v): text someone TYPED (a title, a name, a reference). A value that starts like a formula (=, +, -, @, a tab
 *    or a carriage return) gets a leading apostrophe, so Excel shows the text instead of running it; a value with a
 *    semicolon, a quote or a line break is quoted, its quotes doubled. null and undefined are empty.
 *  - num(v): a number WE wrote (formatKr(ore, { grouped: false }), a count). Never escaped: a minus sign is ours, not a
 *    formula someone typed, and «-5,00» must stay a number the accountant can sum.
 *  - table(head, rows): the header (cells) and the lines (each already joined with line()), as the file.
 *
 * Pure: no I/O.
 */
'use strict';

const FORMULA_START = /^[=+\-@\t\r]/;
function cell(v) {
  let s = String(v ?? '');
  if (FORMULA_START.test(s)) s = `'${s}`;
  return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}
const num = (v) => String(v ?? '');
/** One line from cells already made with cell() or num(). */
const line = (cells) => cells.join(';');
const table = (head, lines) => [line(head.map(cell)), ...lines].join('\r\n') + '\r\n';

module.exports = { FORMULA_START, cell, num, line, table };
